<template>
  <div v-if="showComponent">
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <h4>{{textToRender}}</h4>
  </div>
</template>

<script>
// Utils
import LmCommonProps from '@/mixins/LmCommonProps'

export default {
  mixins: [LmCommonProps],
  data () {
    return {
      textData: ''
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: '',
      required: true
    },
    showEditButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textToRender () {
      return this.text || this.textData
    }
  }
}
</script>
